module.exports = __webpack_public_path__ + "assets/img/recruit2.e707f627.png";